export enum RIGHT_SIDEBAR_EVENTS_TYPES {
  CLOSE = 'close',
  OPEN = 'open',
}
